import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';

export interface AgControlComponentParams extends ICellRendererParams {
  changeHandler: (event?: unknown) => void;
  formGroup: UntypedFormGroup;
  size?: 'auto' | 'compact';
}

export const noop = () => {};

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  template: ``,
})
export class AgControlComponent implements ICellRendererAngularComp {
  fieldName?: string;
  formControl!: UntypedFormControl;
  formGroup$ = new BehaviorSubject<null | UntypedFormGroup>(null);
  isReady$ = new BehaviorSubject(false);
  params!: AgControlComponentParams;
  protected value!: string;

  agInit(params: AgControlComponentParams) {
    this.value = params.value;
    this.fieldName = params.colDef?.field;
    this.changeHandler = params.changeHandler;

    this.updateView(params);
  }

  changeHandler: (event?: unknown) => void = () => {};

  get controlHeightClass() {
    return this.params.size === 'compact' ? `h-9` : '';
  }

  get hasError(): boolean {
    return this.formControl.errors !== null && this.formControl.touched;
  }

  refresh(params: ICellRendererParams): boolean {
    this.updateView(params);

    return true;
  }

  protected updateView(params: ICellRendererParams) {
    const entityId = params?.data?.id;

    if (this.fieldName && params.context?.formGroup?.controls?.table) {
      this.formGroup$.next(params.context.formGroup);

      const tableControls = params.context.formGroup.controls.table.controls;
      const rowControl = tableControls.find(
        (control: UntypedFormGroup) => control.value.id === entityId
      );

      if (tableControls && rowControl) {
        this.formControl = rowControl.controls[this.fieldName];
        this.isReady$.next(true);
      }
    }
  }
}
